import { render, staticRenderFns } from "./IncProductSuggestedList.vue?vue&type=template&id=1dab9471"
import script from "./IncProductSuggestedList.vue?vue&type=script&lang=js"
export * from "./IncProductSuggestedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports